import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ColumnDef, CommonConstants, PageNotes, SortInfo, TableHeader } from '../../global/interfaces';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { AppState } from '../../reducers';
import {
  LoadMobileStatementsAction,
  LoadStatementsAction,
  LoadStatementTypesAction,
  ResetMobileStatementsAction,
  SetStatementsFromFilterAction,
  SetStatementsMobilePaginationAction,
  SetStatementsPaginationAction,
  SetStatementsSortAction,
  SetStatementsToFilterAction,
  SetStatementsTypeFilterAction,
  StatementsFileDownloadAction,
  ResetStatementsAction,
  DownloadStatementsZipAction
} from './statements.actions';
import {
  selectStatementsDocumentsData,
  selectStatementsDocumentsTotal,
  selectStatementsFilter,
  selectStatementsFilterFrom,
  selectStatementsFilterTo,
  selectStatementsFilterType,
  selectStatementsLoading,
  selectStatementsMobile,
  selectStatementsMobileData,
  selectStatementsMobileLoadParameters,
  selectStatementsMobilePagination,
  selectStatementsPagination,
  selectStatementsPayloadData,
  selectStatementsSort,
  selectStatementsTypes,
} from './statements.selectors';
import {
  selectCountrySelected,
  selectMainFilterSelectedAccount,
  selectMainFilterSelectedClient,
  selectMainPageNotes
} from '../../shared/layout/main.selectors';
import { DocumentType } from './statements.models';
import { formatDate } from '../../global/dates';
import { Document } from '../documents/documents.models';
import { WindowResizeService } from '../../global/window-resize.service';
import { isEqual } from 'lodash';
import { StatementEffects } from './statements.effects';
import * as moment from 'moment';
import { isNullOrUndefined, types } from 'util';
import { selectAuthUserFinancialYearStartMonth } from '../auth/auth.selectors';
import { HaloSelectComponent } from 'atlas-field';
import { PaginationComponent, PaginationInfo } from 'atlas-pagination';
import { DateTime } from 'luxon';
import { DateAdapter } from 'atlas-cdk';
import { FieldSize } from 'atlas-cdk';
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';

@Component({
  standalone: false,
  selector: 'dsp-statements',
  templateUrl: 'statements.container.html',
  styleUrls: ['statements.container.scss']
  // encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatementsContainerComponent implements OnInit, OnDestroy {
  dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  dropdownPlacementLeftStart = DropdownPlacement.LeftStart;
  // public headers: TableHeader[] = [
  //   {
  //     name: 'Date',
  //     column: 'date',
  //     sortable: true

  //   },
  //   {
  //     name: 'Document Type',
  //     column: 'subtype',
  //     sortable: true

  //   },
  //   {
  //     name: 'Account Name',
  //     column: 'account',
  //     sortable: true

  //   },
  //   {
  //     name: 'Action',
  //     column: 'action',
  //     textAlign: 'right'
  //   }
  // ];
  sizeMedium = FieldSize.medium;
  sizeSmall = FieldSize.small;

  public headers: ColumnDef[] = [
    {
      displayLabel: 'Date',
      fieldKey: 'date',
      sortable: {
        direction: 'desc',
        sortOnLoad: true
      }
    },
    {
      displayLabel: 'Document Type',
      fieldKey: 'subtype',
      sortable: true

    },
    {
      displayLabel: 'Account Name',
      fieldKey: 'account',
      sortable: true

    },
    {
      displayLabel: 'Action',
      fieldKey: 'action',
      sortable: false,
      // textAlign: 'right'
    }
  ];


  public countryList: any = [

    { label: 'India', code: 'IN' },

    { label: 'Belarus', code: 'BY' },

    { label: 'Canada', code: 'CA' },

    { label: 'Japan', code: 'JP' },

    { label: 'Denmark', code: 'DK' },

    { label: 'Egypt', code: 'EG' },

    { label: 'France', code: 'FR' },

    { label: 'Argentina', code: 'AR' },

    { label: 'Germany', code: 'DE' },

    { label: 'Hungary', code: 'HU' },

    { label: 'India', code: 'IN' },

    { label: 'Belarus', code: 'BY' },

    { label: 'Canada', code: 'CA' },

    { label: 'Japan', code: 'JP' },

    { label: 'Denmark', code: 'DK' },

    { label: 'Egypt', code: 'EG' },

    { label: 'France', code: 'FR' },

    { label: 'Argentina', code: 'AR' },

    { label: 'Germany', code: 'DE' },

    { label: 'Hungary', code: 'HU' },

    { label: 'India', code: 'IN' },

    { label: 'Belarus', code: 'BY' },

    { label: 'Canada', code: 'CA' },

    { label: 'Japan', code: 'JP' },

    { label: 'Denmark', code: 'DK' },

    { label: 'Egypt', code: 'EG' },

    { label: 'France', code: 'FR' },

    { label: 'Argentina', code: 'AR' },

    { label: 'Germany', code: 'DE' },

    { label: 'Hungary', code: 'HU' },

  ];

  countriesFiltered = this.countryList;





  public type: string[];
  public from: string;
  public to: string;
  public accountNumber: string;
  public accountId;
  public defaultSortBy: SortInfo = { column: 'date', reverse: true };
  public statements$: Observable<Document[]>;
  public mobileStatements$: Observable<Document[]>;
  public sort$: Observable<SortInfo>;
  public pagination$: BehaviorSubject<PaginationInfo> = new BehaviorSubject({ page: 1, itemsByPage: 10, total: 0 });
  public documentIds: string[];

  public types$: BehaviorSubject<DocumentType[]> = new BehaviorSubject([]);
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showLoadMore$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>({} as PageNotes);
  public month: number;
  public loading$: Observable<boolean>;

  private readonly subscription: Subscription = new Subscription();
  private payload: any;
  public flagType = false;


  // public columnDef: any = [{
  //   displayLabel: 'Age', fieldKey: 'age',
  //   sortable: false,
  // }, { displayLabel: 'Name', fieldKey: 'name', sortable: true, },
  // { displayLabel: 'Birthplace', fieldKey: 'birthplace', sortable: true, }, {
  //   displayLabel: 'Cars', fieldKey: 'cars', sortable: false,
  // }];
  // public rows: any = [{
  //   age:
  //     '1', name: 'Kevin', birthplace: 'New York', cars: 'Ford',
  // }, {
  //   age: '12', name:
  //     'Helen', birthplace: 'California', cars: 'Infiniti',
  // }, {
  //   age: '35', name:
  //     'Matt', birthplace: 'Florida', cars: 'Toyota', selected: true,
  // }, {
  //   age: '42',
  //   name: 'Robert', birthplace: 'Connecticut', cars: 'Subaru',
  // }]
  public parentChecked = false;
  public parentIndeterminate = false;
  public child1Checked = false;
  public typesOptions: any[] = [];
  // public child2Checked = false;

  public childCheckbox1 = 'childCheckbox1';
  // public childCheckbox2 = 'childCheckbox2';


  @ViewChild('selectCountries') selectCountries: HaloSelectComponent;

  public constructor(
    private readonly store: Store<AppState>,
    private readonly resize: WindowResizeService,
    private readonly statement: StatementEffects,
    private readonly _dateAdapter: DateAdapter<any>

    // private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.loading$ = this.selectLoading();
    this.statements$ = this.selectStatements();
    this.mobileStatements$ = this.selectMobileStatements();
    this.sort$ = this.selectSort();
    //this.pagination$ = this.selectPagination();
    this._dateAdapter.setLocale('en-GB');

  }

  public ngOnInit(): void {
    // Set default sort before any data loads to ensure descending date sort on page load
    this.onSort(this.defaultSortBy.column, 'initial');
    this.subscription.add(this.getFinancialYearStartMonth());
    this.subscription.add(this.subscribeDocumentTypes());
    this.subscription.add(this.subscribeLoadDocumentTypes());
    this.subscription.add(this.subscribeLoadMobileStatements());
    this.subscription.add(this.subscribeLoadStatements());
    this.subscription.add(this.subscribeFilterType());
    this.subscription.add(this.subscribeInitialFilterType());
    this.subscription.add(this.subscribeFilterFrom());
    this.subscription.add(this.subscribeFilterTo());
    this.subscription.add(this.subscribeResetData());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeShowLoadMore());
    this.subscription.add(this.subscribeNotes());
    this.subscription.add(this.subscribePagination());
  }
  onParentChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.parentChecked = input.checked;
    this.parentIndeterminate = input.indeterminate;

    this.child1Checked = this.parentChecked;
    if (this.parentChecked) {
      this.store.pipe(
        select(selectStatementsFilterType)
      ).subscribe(type => {

        this.type = type;
      });
    }

    // this.child2Checked = this.parentChecked;
  }

  onChildChange(event: Event) {

    const input = event.target as HTMLInputElement;
    if (input.id === this.childCheckbox1) {
      this.child1Checked = input.checked;
    }
    // else if (input.id === this.childCheckbox2) {
    //   this.child2Checked = input.checked;
    // }

    // const allChecked = this.child1Checked && this.child2Checked;
    const allChecked = this.child1Checked;

    // const noneChecked = !this.child1Checked && !this.child2Checked;
    const noneChecked = !this.child1Checked;


    this.parentChecked = allChecked;
    // this.parentIndeterminate = !allChecked && !noneChecked;
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectStatementsLoading)
    );
  }

  public getFinancialYearStartMonth(): Subscription {
    return this.store.pipe(
      select(selectAuthUserFinancialYearStartMonth)
    ).subscribe(month => {
      if (!isNullOrUndefined(month)) {
        this.month = month;
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onChangeType(event: string[]): void {
    try {
      // this._changeDetectorRef.detectChanges();
      if (this.selectCountries) {
        this.selectCountries.deselectAll();
      }
      this.statement.paginationFilter = true;
      /**
       * If on mobile, reset mobile state to trigger reloading of statements
       */
      if (this.isMobile$.value) {
        this.store.dispatch(new ResetMobileStatementsAction());
      }

      this.store.dispatch(new SetStatementsTypeFilterAction(event));
      this.statement.paginationFilter = false;

      if (this.type.length == 0) {
        this.flagType = true;
      }
    } catch (error) {
    }
  }

  public onChangeFrom(event: any): void {
    const formatted = event.value ? DateTime.fromJSDate(event.value).toFormat('dd MMM yyyy') : '';
    event = formatted
    this.statement.paginationFilter = true;
    this.store.pipe(
      select(selectStatementsFilterFrom),
      take(1)
    ).subscribe(from => {
      if (!!event && formatDate(event, CommonConstants.DBDateFormat) !== from) {
        /**
         * If on mobile, reset mobile state to trigger reloading of statements
         */
        if (this.isMobile$.value) {
          this.store.dispatch(new ResetMobileStatementsAction());
        }

        this.store.dispatch(new SetStatementsFromFilterAction(formatDate(event, CommonConstants.DBDateFormat)));
      }
      this.statement.paginationFilter = false;
    });
  }
  //  public onChangeFrom(event: any): void {
  //     const formatted = event.value ? DateTime.fromJSDate(event.value).toFormat('M/d/yyyy') : '';
  //   }




  // public onChangeTo(event: any): void {
  //   const formatted = event.value ? DateTime.fromJSDate(event.value).toFormat('M/d/yyyy') : '';
  // }
  public financialYearDate(financialYearStartMonth): void {

    let fromDate: string;
    const todayDate = moment().utc().format(CommonConstants.DBDateFormat),
      year = moment().utc().year();
    if (todayDate > moment(`01-${financialYearStartMonth}-` + year,
      CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat)) {
      fromDate = moment(`01-${financialYearStartMonth}-` + year,
        CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat);
    } else {
      fromDate = moment(`01-${financialYearStartMonth}-` + (year - 1),
        CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat);
    }
    this.from = fromDate;
    this.store.dispatch(new SetStatementsFromFilterAction(formatDate(fromDate,
      CommonConstants.DBDateFormat)));
  }

  public onChangeTo(event: any): void {
    const formatted = event.value ? DateTime.fromJSDate(event.value).toFormat('M/d/yyyy') : '';
    event = formatted
    this.statement.paginationFilter = true;
    this.store.pipe(
      select(selectStatementsFilterTo),
      take(1)
    ).subscribe(to => {

      if (!!event && formatDate(event, CommonConstants.DBDateFormat) !== to) {

        /**
         * If on mobile, reset mobile state to trigger reloading of statements
         */
        if (this.isMobile$.value) {
          this.store.dispatch(new ResetMobileStatementsAction());
        }

        this.store.dispatch(new SetStatementsToFilterAction(formatDate(event, CommonConstants.DBDateFormat)));
      }
      this.statement.paginationFilter = false;
    });
  }

  public onSort(name, direction): void {

    let sortObj: SortInfo = { column: '', reverse: false }
    if (direction && name) {
      sortObj.column = name
      if (direction === 'initial' || direction === 'asc') {
        sortObj.reverse = false
      }
      if (direction === 'desc') {
        sortObj.reverse = true
      }
      this.store.dispatch(new SetStatementsSortAction(sortObj));
    }
  }

  public onPaginate(event: PaginationInfo): void {
    this.store.dispatch(new SetStatementsPaginationAction(event));
  }

  /**
   * Acts as pagination for mobile
   */
  public onLoadMore(): void {
    this.store.pipe(select(selectStatementsMobilePagination), take(1)).subscribe(pagination => {
      this.store.dispatch(new SetStatementsMobilePaginationAction({ ...pagination }));

    });
  }

  public onExportPDF(event: Document): void {

    this.store.dispatch(new StatementsFileDownloadAction({ id: event._id, originalName: event.originalName }));
  }

  private subscribeInitialFilterType(): Subscription {
    return this.types$.subscribe(types => {
      this.flagType = false
      this.typesOptions = types.map(type => ({
        label: type.name,
        value: type.value
      }));
      // this._changeDetectorRef.detectChanges();
      this.onChangeType(types.map(type => type.value));

    });
  }

  public subscribeFilterType(): Subscription {
    return this.store.pipe(
      select(selectStatementsFilterType)
    ).subscribe(type => {
      this.type = type;
      // this._changeDetectorRef.detectChanges();
    });
  }

  public subscribeFilterFrom(): Subscription {
    return this.store.pipe(
      select(selectStatementsFilterFrom)
    ).subscribe(from => {
      if (!isNullOrUndefined(from)) {
        this.from = from;
      } else {
        this.financialYearDate(this.month);
      }
    });
  }

  public subscribeFilterTo(): Subscription {
    return this.store.pipe(
      select(selectStatementsFilterTo)
    ).subscribe(to => {
      this.to = to;
    });
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private subscribeLoadMobileStatements(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectStatementsMobileLoadParameters)),
    //   this.isMobile$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectStatementsMobileLoadParameters)),
      this.isMobile$]
    ).pipe(
      /**
       * Use general state selector to avoid typescript issues
       */
      filter(([client, state, isMobile]) =>
      (!!isMobile &&
        (state.mobile.data.length === 0) &&
        (state.mobile.total === 0 || state.mobile.total > state.mobile.data.length)
      )),
      /**
       * Map data to a specific format in order to reuse payload mapping function
       */
      map(([client, state]) =>
      ([client, state.filter, state.sort, state.mobilePagination]
      )),
      this.mapDataLoadPayload(),
      distinctUntilChanged(isEqual)
    ).subscribe(payload => {
      this.store.dispatch(new LoadMobileStatementsAction(payload));
    });
  }

  private subscribeLoadStatements(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectStatementsFilter)),
    //   this.store.pipe(select(selectStatementsSort)),
    //   this.store.pipe(select(selectStatementsPagination)),
    //   this.store.pipe(select(selectCountrySelected)),
    //   this.isMobile$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectStatementsFilter)),
      this.store.pipe(select(selectStatementsSort)),
      this.store.pipe(select(selectStatementsPagination)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectStatementsPayloadData)),
      this.isMobile$]
    ).pipe(
      filter(([filter, sort, pagination, country, statementPayload, isMobile]) => !isNullOrUndefined(filter) &&
        !isNullOrUndefined(filter.from) && !isMobile),
      map(([filter, sort, pagination, country, statementPayload]) => ({
        account: '',
        type: 'client-statements',
        subtype: filter.type.join(';'),
        from: filter.from,
        to: filter.to,
        sort,
        pagination,
        country,
        ...statementPayload
      })),
      distinctUntilChanged(isEqual)
    ).subscribe(payload => {
      if (!!this.accountId) {
        payload['account'] = this.accountId;
        this.payload = payload;
        this.store.dispatch(new LoadStatementsAction(payload));
      }
    });
  }

  private subscribeLoadDocumentTypes(): Subscription {
    return this.store.pipe(select(selectMainFilterSelectedAccount))
      .subscribe(account => {
        if (!!account) {
          this.accountId = account._id;
          this.store.dispatch(new LoadStatementTypesAction({ account: account._id }));
        }
      });
  }

  private subscribeResetData(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount)
    ).subscribe(account => {
      this.accountId = '000000000000000000000000';
      if (!!account) {
        this.accountId = account._id;
      }
      this.store.dispatch(new ResetStatementsAction());
    });
  }

  private subscribeShowLoadMore(): Subscription {
    return this.store.pipe(
      select(selectStatementsMobile),
      map(state => state.total !== 0 && state.total > state.data.length)
    ).subscribe(this.showLoadMore$);
  }

  private subscribeDocumentTypes(): Subscription {
    return this.store.pipe(
      select(selectStatementsTypes),
      // map(types => types.map(type => {
      //   name: this.formatSubtype(type),
      //   value: type,
      map(types => types.map(type => {
        return {
          name: this.formatSubtype(type),
          value: type,
        };
      }))
    ).subscribe(this.types$);

    // this.typesOptions = this.type.map(fund => ({
    //     label: 
    //     value: 
    //   }));
  }

  private subscribeNotes(): Subscription {
    return this.store.pipe(
      select(selectMainPageNotes)
    ).subscribe(this.notes$);
  }

  private subscribePagination(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectDocumentPagination)),
    //   this.store.pipe(select(selectDocumentDataTotal))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectStatementsPagination)),
      this.store.pipe(select(selectStatementsDocumentsTotal))
    ]).pipe(
      map(([pagination, total]) => ({ ...pagination, total }))
    ).subscribe(this.pagination$);
  }

  private selectStatements(): Observable<Document[]> {
    return this.store.pipe(
      select(selectStatementsDocumentsData),
      map(data => data.map(document => ({
        ...document,
        date: !!document.date ? formatDate(document.date) : '',
        dateTimestamp: !!document.date ? new Date(document.date).getTime() : 0,
        subtype: !!document.subtype ? this.formatSubtype(document.subtype) : ''
      })))
    );
  }

  private selectMobileStatements(): Observable<Document[]> {
    return this.store.pipe(
      select(selectStatementsMobileData),
      map(data => data.map(document => ({
        ...document,
        date: !!document.date ? formatDate(document.date) : '',
        subtype: !!document.subtype ? this.formatSubtype(document.subtype) : ''
      })))
    );
  }

  private selectSort(): Observable<SortInfo> {
    return this.store.pipe(
      select(selectStatementsSort),
      map(sort => ({
        column: sort.column,
        reverse: sort.reverse
      }))
    );
  }

  // private selectPagination(): Observable<PaginationInfo> {
  //   // return combineLatest(
  //   //   this.store.pipe(select(selectStatementsDocumentsTotal)),
  //   //   this.store.pipe(select(selectStatementsPagination)),
  //   // ).pipe(
  //   return combineLatest([
  //     this.store.pipe(select(selectStatementsDocumentsTotal)),
  //     this.store.pipe(select(selectStatementsPagination))]
  //   ).pipe(
  //     map(([total, pagination]) => ({ total, ...pagination }))
  //   );
  // }

  private mapDataLoadPayload() {
    return map(([account, filter, sort, pagination]) => ({
      account: account._id,
      type: 'client-statements',
      subtype: filter.type.join(';'),
      from: filter.from,
      to: filter.to,
      sort,
      pagination
    }));
  }

  private formatSubtype(subtype: string): string {
    const array = subtype.split('_');

    for (let i = 0; i < array.length; i++) {
      array[i] = array[i].charAt(0).toUpperCase() + array[i].substring(1);
    }

    return array.join(' ');
  }

  public zipFileName(): Observable<string> {
    return this.store.pipe(select(selectMainFilterSelectedAccount), take(1)).pipe(
      map(account => {
        this.accountNumber = account.number;
        const formattedFromDate = formatDate(this.from, 'DDMMYYYY');
        const formattedToDate = formatDate(this.to, 'DDMMYYYY');
        return `Statements_${this.accountNumber}_${formattedFromDate}_${formattedToDate}.zip`;
      })
    );
  }
  public onDownloadZip(): void {
    this.zipFileName().subscribe(originalName => {
      this.store.dispatch(new DownloadStatementsZipAction({ ...this.payload, originalName }));
    });
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
